import React, { useContext } from "react";
import {
	Controller,
	ControllerRenderProps,
	useFormContext,
} from "react-hook-form";

import { DatePickerCommon, DatePickerWithLoaderWrapper } from "components";
import { FilterColumnDateProps } from "types";

import FiltersContext from "../filtersContext";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumnDateProps;
};

const FilterDatePicker = ({ column }: FilterColumnProps) => {
	const { loading } = useContext(FiltersContext);
	const { control, setValue } = useFormContext();

	return (
		<Controller
			control={control}
			name={column.name || ""}
			defaultValue={null}
			render={({ field }: { field: ControllerRenderProps }) => (
				<DatePickerWithLoaderWrapper
					input={field}
					isLoading={!!loading}
					renderDatePicker={input => (
						<DatePickerCommon
							value={input?.value}
							onChange={value => {
								setValue(input?.name || "", value);
							}}
							placeholderText={column.placeholder}
							wrapperClassName={styles.column}
							minDate={column.minDate}
							maxDate={column.maxDate}
						/>
					)}
				/>
			)}
		/>
	);
};

export default FilterDatePicker;
